import { render, staticRenderFns } from "./IconDESC.vue?vue&type=template&id=8f3a9ef8"
import script from "./IconDESC.vue?vue&type=script&lang=ts"
export * from "./IconDESC.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports